// extracted by mini-css-extract-plugin
export default {"DynamicValue":"RenderSingleCategory_DynamicValue__3XlrW","toggleContainer":"RenderSingleCategory_toggleContainer__HIbZ2"};